export default "__VITE_ASSET__WzwSawi8__"